import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { MailX } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const email = params.get('e') || '';
  const [state, setState] = useState('working');

  useEffect(() => {
    if (!email) { setState('missing'); return; }
    fetch(`${API}/api/leads/unsubscribe?e=${encodeURIComponent(email)}`)
      .then((r) => (r.ok ? setState('done') : setState('error')))
      .catch(() => setState('error'));
  }, [email]);

  return (
    <main className="pt-20 min-h-screen bg-black text-white flex items-center justify-center px-6" data-testid="unsubscribe-page">
      <div className="max-w-md w-full bg-zinc-900 border border-zinc-800 p-8 text-center">
        <MailX className="w-8 h-8 text-[#C7FA3E] mx-auto mb-4" />
        {state === 'working' && <p className="text-zinc-400">Unsubscribing…</p>}
        {state === 'done' && (
          <>
            <h1 className="text-2xl mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>You are unsubscribed</h1>
            <p className="text-zinc-400 text-sm mb-6">{email} will not receive any more check-in emails from us.</p>
          </>
        )}
        {state === 'missing' && <p className="text-zinc-400 text-sm mb-6">No email address provided in the link.</p>}
        {state === 'error' && <p className="text-zinc-400 text-sm mb-6">Something went wrong. Reply to any of our emails and we will remove you by hand.</p>}
        <Link to="/" className="text-[#C7FA3E] text-sm font-bold" data-testid="unsubscribe-home-link">Back to NinjAthlete</Link>
      </div>
    </main>
  );
}
